// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__YCRpO","avatar":"style_avatar__WgWOC"};